import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) =>
  createStyles({
    tooltipContainer: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(-0.4),
      cursor: 'pointer',
    },
    formHelperTextError: {
      color: `${Colors.error} !important`,
    },
  }),
);
